// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-shared-entry-actions-notice__notice-container {
  max-width: 250px;
  border-radius: 5px;
  background-color: var(--g-color-base-info-light);
  padding: 4px 8px;
}
.dl-shared-entry-actions-notice__notice-text {
  font: var(--g-text-body-1-font);
  line-height: var(--g-text-body-1-line-height);
  margin: 0;
  text-align: left;
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/collections/components/CollectionActions/components/SharedEntryNotice/SharedEntryNotice.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,gBAAA;AAAR;AAGI;EACI,+BAAA;EACA,6CAAA;EACA,SAAA;EACA,gBAAA;EACA,oCAAA;AADR","sourcesContent":[".dl-shared-entry-actions-notice__notice-container {\n  max-width: 250px;\n  border-radius: 5px;\n  background-color: var(--g-color-base-info-light);\n  padding: 4px 8px;\n}\n.dl-shared-entry-actions-notice__notice-text {\n  font: var(--g-text-body-1-font);\n  line-height: var(--g-text-body-1-line-height);\n  margin: 0;\n  text-align: left;\n  color: var(--g-color-text-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
